/* istanbul ignore file */
import NavigationProvider from './NavigationProvider';

export { useNavigation } from './use-navigation';
export default NavigationProvider;
